module.exports = __webpack_public_path__ + "img/困.77d33c99.png";